import type { ProductTaxonomyRenameDefinition } from '../types';

export const broadcastsRename = {
  terms: {
    broadcasts: {
      current: {
        singular: 'newsletter',
        plural: 'newsletters',
        titleSingular: 'Newsletter',
        titlePlural: 'Newsletters',
      },
      future: {
        singular: 'one-time send',
        plural: 'one-time sends',
        titleSingular: 'One-time send',
        titlePlural: 'One-time sends',
      },
    },
  },
  copy: {
    'nav.broadcasts.newsletters': {
      term: 'broadcasts.titlePlural',
    },
    'nav.broadcasts.apiTriggered': {
      current: 'API-triggered',
      future: 'API-triggered workflow',
    },
    'broadcasts.apiTriggered.singularTitleHyphenated': {
      current: 'API-Triggered Broadcast',
      future: 'API-triggered workflow',
    },
  },
  routes: {
    'broadcasts.oneTimeSends': {
      current: '/workspaces/:workspaceId/journeys/broadcasts/newsletters',
      future: '/workspaces/:workspaceId/journeys/broadcasts/one_time_sends',
    },
    'broadcasts.apiTriggered': {
      current: '/workspaces/:workspaceId/journeys/broadcasts/api-triggered',
      future: '/workspaces/:workspaceId/journeys/broadcasts/api-triggered',
    },
  },
} as const satisfies ProductTaxonomyRenameDefinition;
